((global) => {
  function stopMedia(slide) {
    slide.querySelectorAll('video,model-viewer').forEach((media) => media.pause?.());
    slide.querySelectorAll('iframe').forEach((frame) => {
      frame.contentWindow?.postMessage?.('{"event":"command","func":"pauseVideo","args":""}', '*');
      frame.contentWindow?.postMessage?.('{"method":"pause"}', '*');
      const source = frame.getAttribute?.('src');
      if (source) frame.setAttribute('src', source);
    });
  }

  function select(root, mediaId) {
    if (!root || mediaId == null) return false;
    const id = String(mediaId);
    const slides = [...root.querySelectorAll('[data-product-media]')];
    const thumbnails = [...root.querySelectorAll('[data-product-thumbnail]')];
    const active = slides.find((slide) => slide.dataset.mediaId === id);
    if (!active) return false;
    slides.forEach((slide) => {
      const selected = slide === active;
      slide.hidden = !selected;
      slide.setAttribute('aria-hidden', String(!selected));
      if (!selected) stopMedia(slide);
    });
    thumbnails.forEach((thumbnail) => {
      const selected = thumbnail.dataset.mediaId === id;
      thumbnail.setAttribute('aria-current', selected ? 'true' : 'false');
    });
    return true;
  }

  function init(root) {
    if (!root || root.dataset.productGalleryInitialized === 'true') return;
    root.dataset.productGalleryInitialized = 'true';
    const clickHandler = (event) => {
      const thumbnail = event.target.closest('[data-product-thumbnail]');
      if (thumbnail) select(root, thumbnail.dataset.mediaId);
    };
    root.mcProductGalleryClickHandler = clickHandler;
    root.addEventListener('click', clickHandler);
  }

  function destroy(root) {
    if (!root) return;
    if (root.mcProductGalleryClickHandler) root.removeEventListener('click', root.mcProductGalleryClickHandler);
    delete root.mcProductGalleryClickHandler;
    delete root.dataset.productGalleryInitialized;
  }

  global.MoveCalmlyProductGallery = Object.freeze({ destroy, init, select, stopMedia });
})(window);
